<template>
	<ul class="list-unstyled">
		<li v-for="masechta in masechtos" :key="masechta.id" class="py-2 border-bottom border-primary d-flex">
			<router-link :to="{name:'masechta', params:{slug:masechta.url_key}}">
				<highlight :msg="masechta.name" :search="query" effect="highlight" /></router-link>
		</li>
	</ul>
</template>
<script>
	import HighlightComponent from './Highlight.vue';
	export default {
		props: ['masechtos', 'query'],
		components: {
			Highlight: HighlightComponent
		}
	}
</script>
<style>
	
</style>